<template>
	<v-form
		v-model="valid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			align-center
			pt-2
		>
			<v-flex
				xs12
				sm6
				py-0
			>
				<v-text-field
					v-model="publication.name"
					:rules="[...validate.require, validate.max(publication.name, 100)]"
					label="Name"
					name="name"
				/>
			</v-flex>
			<v-flex
				xs12
				sm6
				py-0
			>
				<v-text-field
					v-model="publication.urlId"
					:rules="[...validate.require, validate.max(publication.urlId, 255)]"
					label="URL ID"
					name="urlId"
				/>
			</v-flex>
			<v-flex
				xs12
				sm6
				py-0
			>
				<v-autocomplete
					v-model="publication.country"
					:items="countries"
					:filter="countryFilter"
					:rules="[...validate.require, validate.max(publication.country, 2)]"
					item-value="value"
					item-text="value"
					label="Country"
					persistent-hint
				>
					<template
						slot="item"
						slot-scope="data"
					>
						<div>
							{{ data.item.value }}
							<span>
								- {{ data.item.text }}
							</span>
						</div>
					</template>
				</v-autocomplete>
			</v-flex>
			<v-flex
				xs12
				sm6
				py-0
			>
				<v-text-field
					v-model="publication.popularityManual"
					:rules="validate.number"
					label="Manual Popularity"
					name="popularityManual"
					type="number"
				/>
			</v-flex>
			<v-flex
				xs12
				class="text-xs-center"
			>
				<v-btn
					:disabled="!valid"
					color="primary"
					type="submit"
				>
					Submit
				</v-btn>
				<v-btn
					flat
					color="error"
					@click="close()"
				>
					Close
				</v-btn>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Publication } from '@/models/Publication';
import countryISO from 'i18n-iso-countries/langs/en.json';

export default {
	mixins: [Validation],
	props: {
		editPublication: { type: Object, default: null },
	},
	data() {
		return {
			publication: new Publication(),
			valid: true,
			countries: [],
		};
	},
	created() {
		// eslint-disable-next-line
		for (const property in countryISO.countries) {
			this.countries.push({ text: countryISO.countries[property], value: property });
		}
		if (this.editPublication) {
			this.publication.name = this.editPublication.name;
			this.publication.urlId = this.editPublication.urlId;
			this.publication.country = this.editPublication.country;
			this.publication.popularityManual = this.editPublication.popularityManual;
		}
	},
	methods: {
		submit() {
			if (this.editPublication) {
				this.$emit('update', this.publication);
				return;
			}
			this.$emit('new', this.publication);
		},
		close() {
			this.$emit('close');
		},
		countryFilter(item, queryText) {
			// eslint-disable-next-line
			const hasValue = val => val != null ? val : '';

			const text = hasValue(item.text);
			const value = hasValue(item.value);
			const query = hasValue(queryText);

			return text.toString().toLowerCase()
				.indexOf(query.toString().toLowerCase()) > -1
				|| value.toString().toLowerCase()
					.indexOf(query.toString().toLowerCase()) > -1;
		},
	},
};
</script>

<style>

</style>
